"use client";

import React from "react";
import { FaArrowDown } from "react-icons/fa";
import "./contact.css";

const OnBottom = () => {
    return (
        <div>
            <div
                className="flex justify-center items-center bg-white !rounded-full shadow-2xl cursor-pointer w-20 h-20 py-8 px-10"
                onClick={() => {
                    window.scrollTo({ top: 950, behavior: "smooth" });
                }}
            >
                <div className="border-2 border-[#410EAD] p-1.5 w-10 h-12 rounded-t-full rounded-b-full flex justify-center items-center">
                    {/* Apply animation to the FaArrowDown icon */}
                    <FaArrowDown className="text-[#410EAD] text-xl animate-bounceArrow" />
                </div>
            </div>
        </div>
    );
};

export default OnBottom;
